import { useProductDetailsVariantContext } from '@app/components/products/ProductDetails/context/ProductDetailsVariantContext';
import { getDefaultImageSize, getVariantsThumbnailsLabel } from '@app/ducks';
import { getDefaultImageAspectRatio, getProductImageOrPlaceholderBySize } from '@app/ducks/helpers';
import { GetProductUrl } from '@app/logic/products';
import { Product } from '@typings';
import { useSelector } from 'react-redux';

import { VariantCard } from '../VariantCard';

interface Props {
  activeVariant: Product.Standard;
  variants: Product.Standard[];
  getProductUrl: GetProductUrl;
}

export const NativeVariants = ({ activeVariant, variants, getProductUrl }: Props) => {
  const { setActiveMedia } = useProductDetailsVariantContext();
  const imageSize = useSelector(getDefaultImageSize);
  const aspectRatio = useSelector(getDefaultImageAspectRatio);
  const variantsThumbnailsLabel = useSelector(getVariantsThumbnailsLabel);

  return variants.map(variant => {
    const image = getProductImageOrPlaceholderBySize(variant, imageSize);
    const isActive = activeVariant?.variant === variant.variant;
    const label = variantsThumbnailsLabel === 'none' ? undefined : variant[variantsThumbnailsLabel];

    return (
      <VariantCard
        key={image.variantId}
        aspectRatio={aspectRatio}
        image={image}
        imageSize={imageSize}
        isActive={isActive}
        linkTarget={getProductUrl({ productId: variant.product, variantId: variant.variant })}
        label={label}
        onClick={() => setActiveMedia(image)}
        shouldReplacePath
      />
    );
  });
};
